import { takeLatest } from 'redux-saga/effects';
import { FETCH_QUEUE_DATA_REQUEST } from '../../redux/modules/approvalQueue/approvalQueue-actions';
import getQueueListWorker from './approvalQueueWorkerSaga';

export default function* getQueueListSaga() {
    yield takeLatest(FETCH_QUEUE_DATA_REQUEST, getQueueListWorker);
}
